import { deleteCookie } from "cookies-next/client";

export const handleUnauthorized = () => {
  deleteCookie("token");
  deleteCookie("sessionId");

  console.error("Recieved 401 unauthorized error from back");
};
